<template>
<section class="exhibition-movie-section _preview-section" v-if="exhibitionTitlesPreviewList.length > 0 || exhibitionsYoutubeList.length > 0">
    <div class="section-inner">

        <!-- 展示会情報 -->
        <div class="block" v-if="exhibitionTitlesPreviewList.length > 0">
            <div class="md_hidden-content-wrap">
                <button type="button" class="trigger js-toggle-on _on" @click="toggleShow"><span>展示会・ポップアップ情報</span></button>
                <div class="content"><div class="content-inner">

                    <div class="exhibition-item" v-for="(exhibition_title, i) in exhibitionTitlesPreviewList" v-bind:key="i" >
                        <p class="exhibition-title">
                            <span>{{exhibition_title.name}}</span>
                            <span v-if="exhibition_title.type===0" class="exhibition-type-label">展示会</span>
                            <span v-else-if="exhibition_title.type===1" class="exhibition-type-label">ポップアップ</span>
                        </p>

                        <!--Group-->
                        <div class="input-group exhibition-card" v-for="(exhibition, index) in exhibition_title.exhibitions" v-bind:key="index">
                            <p class="city"><span>{{exhibition.area}}</span></p>
                            <p class="date"><span>{{exhibition.date_time}}</span></p>
                            <p class="place" v-if="exhibition.address">
                                <a class="md_text-link _pin _left" :href="exhibition.google_map_url" target="_blank">
                                    <span>{{exhibition.address}}</span>
                                </a>
                            </p>
                            <p class="detail">
                                <span>{{exhibition.text}}</span>
                            </p>
                        </div>
                    </div>

                </div></div><!--/.Inner-->
            </div><!--/.md_hidden-content-wrap-->
        </div>

        <!-- 動画を見る -->
        <div class="block" v-if="exhibitionsYoutubeList.length > 0 && showMovie">
            <div class="md_hidden-content-wrap">
                <button type="button" class="trigger js-toggle-on _on" @click="toggleShow"><span>MOVIE</span></button>
                <div class="content"><div class="content-inner">

                    <!--Movie-->
                    <div class="movie-card" v-for="(youtube, index) in exhibitionsYoutubeList" v-bind:key="index">
                        <iframe width="560" height="315" :src="youtube.url" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>

                </div></div><!--/.Inner-->
            </div><!--/.md_hidden-content-wrap-->
        </div>

    </div>
</section>
</template>

<script>
    //Svg
    import SvgIconDelete from '@/components/EndUser/svg/SvgIconDelete'

    export default {
        components: {
            SvgIconDelete,
        },
        props: {
            showMovie: Boolean,
        },
        methods: {
            toggleShow(event){
                // v-ifを使うとjqueryでのclick event動かなくなるため
                $(event.target).toggleClass('_on');
            }
        },
        computed: {
            exhibitionTitlesPreviewList() {
                this.$store.state.register.form.exhibition_titles = [];

                for(var i in this.$store.state.register.form.editExhibitionTitles) {
                    var exhibition_title = this.$store.state.register.form.editExhibitionTitles[i];
                    if (exhibition_title.name) {
                        this.$store.state.register.form.exhibition_titles.push(exhibition_title)
                    }
                }

                return this.$store.state.register.form.exhibition_titles;
            },
            exhibitionsYoutubeList() {
                this.$store.state.register.form.youtubes = [];

                for(var i in this.$store.state.register.form.editYoutube) {
                    var youtube = this.$store.state.register.form.editYoutube[i];
                    if (youtube.url) {
                        this.$store.state.register.form.youtubes.push(youtube)
                    }
                }

                return this.$store.state.register.form.youtubes;
            },
        },
    }
</script>

